var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "服务信息" } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox" }, [
        _c("div", { staticClass: "fff" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("服务信息")]),
          _vm._v(" "),
          _c("div", { staticClass: "infoBox" }, [
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("预约老师")]),
              _vm._v(" "),
              _c("div", { staticClass: "infoValue" }, [
                _vm._v(_vm._s(_vm.userBespeakDetail.doctorName))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("咨询方式")]),
              _vm._v(" "),
              _c("div", { staticClass: "infoValue" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("isServeType")(
                      _vm.userBespeakDetail.scaleUserBespeak.serveType
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("咨询次数")]),
              _vm._v(" "),
              _c("div", { staticClass: "infoValue" }, [
                _vm._v(
                  _vm._s(_vm.userBespeakDetail.scaleUserBespeak.bespeakTimes)
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem lastItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("预约时间")]),
              _vm._v(" "),
              _c("div", { staticClass: "infoValue" }, [
                _vm._v(
                  _vm._s(_vm.userBespeakDetail.scaleUserBespeak.bespeakDate)
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fffItem" }, [
          _c("div", { staticClass: "title" }, [_vm._v("来访者信息")]),
          _vm._v(" "),
          _c("div", { staticClass: "infoBox" }, [
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("姓名")]),
              _vm._v(" "),
              _c("div", { staticClass: "infoValue" }, [
                _vm._v(_vm._s(_vm.userBespeakDetail.userName))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem lastItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("手机号")]),
              _vm._v(" "),
              _c("div", { staticClass: "infoValue" }, [
                _vm._v(_vm._s(_vm.userBespeakDetail.userPhone))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("出生地")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "radioBox",
                  on: {
                    click: function($event) {
                      _vm.scaleUserBespeakRegister.birthPlace = 1
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "radioIcon",
                    class: {
                      active: _vm.scaleUserBespeakRegister.birthPlace === 1
                    }
                  }),
                  _vm._v("\n                        城市\n                    ")
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "radioBox",
                  on: {
                    click: function($event) {
                      _vm.scaleUserBespeakRegister.birthPlace = 0
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "radioIcon",
                    class: {
                      active: _vm.scaleUserBespeakRegister.birthPlace === 0
                    }
                  }),
                  _vm._v("\n                        农村\n                    ")
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("是否独生子女")]),
              _vm._v(" "),
              _vm.scaleUserBespeakRegister.onlyChild > 0 ||
              _vm.scaleUserBespeakRegister.onlyChild === 0
                ? _c(
                    "div",
                    {
                      staticClass: "infoValue",
                      on: { click: _vm.openOnlyChild }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("isOnlyChild")(
                            _vm.scaleUserBespeakRegister.onlyChild
                          )
                        )
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "toSelect",
                      on: {
                        click: function($event) {
                          _vm.onlyChildStatus = true
                        }
                      }
                    },
                    [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("宗教信仰")]),
              _vm._v(" "),
              _vm.scaleUserBespeakRegister.religiousBeliefs !== ""
                ? _c(
                    "div",
                    {
                      staticClass: "infoValue",
                      on: { click: _vm.openReligiousBeliefs }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("isReligiousBeliefs")(
                            _vm.scaleUserBespeakRegister.religiousBeliefs
                          )
                        )
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "toSelect",
                      on: {
                        click: function($event) {
                          _vm.religiousBeliefsStatus = true
                        }
                      }
                    },
                    [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "zhzz" }, [
              _c("div", { staticClass: "infoKey1" }, [
                _vm._v("在杭住址(寝室或外宿地址)")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.scaleUserBespeakRegister.address,
                    expression: "scaleUserBespeakRegister.address"
                  }
                ],
                attrs: { type: "text", placeholder: "请输入住址" },
                domProps: { value: _vm.scaleUserBespeakRegister.address },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.scaleUserBespeakRegister,
                      "address",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fffItem" }, [
          _c("div", { staticClass: "title" }, [_vm._v("家庭状况")]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("父亲年龄")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.scaleUserBespeakRegister.fatherAge,
                  expression: "scaleUserBespeakRegister.fatherAge"
                }
              ],
              staticClass: "minInput",
              attrs: { type: "number", placeholder: "请输入" },
              domProps: { value: _vm.scaleUserBespeakRegister.fatherAge },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.scaleUserBespeakRegister,
                    "fatherAge",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" 岁\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("健在")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "radioBox",
                on: {
                  click: function($event) {
                    _vm.scaleUserBespeakRegister.fatherLive = 0
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "radioIcon",
                  class: {
                    active: _vm.scaleUserBespeakRegister.fatherLive === 0
                  }
                }),
                _vm._v("\n                    是\n                ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "radioBox",
                on: {
                  click: function($event) {
                    _vm.scaleUserBespeakRegister.fatherLive = 1
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "radioIcon",
                  class: {
                    active: _vm.scaleUserBespeakRegister.fatherLive === 1
                  }
                }),
                _vm._v("\n                    否\n                ")
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem lastItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("职业")]),
            _vm._v(" "),
            _c("div", { staticClass: "infoValue" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.scaleUserBespeakRegister.fatherWork,
                    expression: "scaleUserBespeakRegister.fatherWork"
                  }
                ],
                staticClass: "medium",
                attrs: { type: "text", placeholder: "请输入" },
                domProps: { value: _vm.scaleUserBespeakRegister.fatherWork },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.scaleUserBespeakRegister,
                      "fatherWork",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem lastItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("学历")]),
            _vm._v(" "),
            _c("div", { staticClass: "infoValue" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.scaleUserBespeakRegister.fatherEducation,
                    expression: "scaleUserBespeakRegister.fatherEducation"
                  }
                ],
                staticClass: "minInput",
                attrs: { type: "text", placeholder: "请输入" },
                domProps: {
                  value: _vm.scaleUserBespeakRegister.fatherEducation
                },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.scaleUserBespeakRegister,
                      "fatherEducation",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("母亲年龄")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.scaleUserBespeakRegister.motherAge,
                  expression: "scaleUserBespeakRegister.motherAge"
                }
              ],
              staticClass: "minInput",
              attrs: { type: "number", placeholder: "请输入" },
              domProps: { value: _vm.scaleUserBespeakRegister.motherAge },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.scaleUserBespeakRegister,
                    "motherAge",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" 岁\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("健在")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "radioBox",
                on: {
                  click: function($event) {
                    _vm.scaleUserBespeakRegister.motherLive = 0
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "radioIcon",
                  class: {
                    active: _vm.scaleUserBespeakRegister.motherLive === 0
                  }
                }),
                _vm._v("\n                    是\n                ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "radioBox",
                on: {
                  click: function($event) {
                    _vm.scaleUserBespeakRegister.motherLive = 1
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "radioIcon",
                  class: {
                    active: _vm.scaleUserBespeakRegister.motherLive === 1
                  }
                }),
                _vm._v("\n                    否\n                ")
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem lastItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("职业")]),
            _vm._v(" "),
            _c("div", { staticClass: "infoValue" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.scaleUserBespeakRegister.motherWork,
                    expression: "scaleUserBespeakRegister.motherWork"
                  }
                ],
                staticClass: "medium",
                attrs: { type: "text", placeholder: "请输入" },
                domProps: { value: _vm.scaleUserBespeakRegister.motherWork },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.scaleUserBespeakRegister,
                      "motherWork",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem lastItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("学历")]),
            _vm._v(" "),
            _c("div", { staticClass: "infoValue" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.scaleUserBespeakRegister.motherEducation,
                    expression: "scaleUserBespeakRegister.motherEducation"
                  }
                ],
                staticClass: "minInput",
                attrs: { type: "text", placeholder: "请输入" },
                domProps: {
                  value: _vm.scaleUserBespeakRegister.motherEducation
                },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.scaleUserBespeakRegister,
                      "motherEducation",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("家庭结构")]),
            _vm._v(" "),
            _vm.scaleUserBespeakRegister.familyState === ""
              ? _c(
                  "div",
                  {
                    staticClass: "toSelect",
                    on: {
                      click: function($event) {
                        _vm.familyStateStatus = true
                      }
                    }
                  },
                  [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                )
              : _c(
                  "div",
                  {
                    staticClass: "infoValue",
                    on: {
                      click: function($event) {
                        _vm.familyStateStatus = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("isFamilyState")(
                          _vm.scaleUserBespeakRegister.familyState
                        )
                      )
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("父母婚姻状况")]),
            _vm._v(" "),
            _vm.scaleUserBespeakRegister.parentMarital === ""
              ? _c(
                  "div",
                  {
                    staticClass: "toSelect",
                    on: {
                      click: function($event) {
                        _vm.parentMaritalStatus = true
                      }
                    }
                  },
                  [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                )
              : _c(
                  "div",
                  {
                    staticClass: "infoValue",
                    on: {
                      click: function($event) {
                        _vm.parentMaritalStatus = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("isParentMarital")(
                          _vm.scaleUserBespeakRegister.parentMarital
                        )
                      )
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("家庭经济条件")]),
            _vm._v(" "),
            _vm.scaleUserBespeakRegister.familyEconomic === ""
              ? _c(
                  "div",
                  {
                    staticClass: "toSelect",
                    on: {
                      click: function($event) {
                        _vm.familyEconomicStatus = true
                      }
                    }
                  },
                  [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                )
              : _c(
                  "div",
                  {
                    staticClass: "infoValue",
                    on: {
                      click: function($event) {
                        _vm.familyEconomicStatus = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("isFamilyEconomic")(
                          _vm.scaleUserBespeakRegister.familyEconomic
                        )
                      )
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("家族精神类疾病史")]),
            _vm._v(" "),
            _vm.scaleUserBespeakRegister.familyMentalIllness === ""
              ? _c(
                  "div",
                  {
                    staticClass: "toSelect",
                    on: {
                      click: function($event) {
                        _vm.familyMentalIllnessStatus = true
                      }
                    }
                  },
                  [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                )
              : _c(
                  "div",
                  {
                    staticClass: "infoValue",
                    on: {
                      click: function($event) {
                        _vm.familyMentalIllnessStatus = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("isFamilyMentalIllness")(
                          _vm.scaleUserBespeakRegister.familyMentalIllness
                        )
                      )
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("家庭氛围")]),
            _vm._v(" "),
            _vm.scaleUserBespeakRegister.familyHappy === ""
              ? _c(
                  "div",
                  {
                    staticClass: "toSelect",
                    on: {
                      click: function($event) {
                        _vm.familyHappyStatus = true
                      }
                    }
                  },
                  [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                )
              : _c(
                  "div",
                  {
                    staticClass: "infoValue",
                    on: {
                      click: function($event) {
                        _vm.familyHappyStatus = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("isFamilyHappy")(
                          _vm.scaleUserBespeakRegister.familyHappy
                        )
                      )
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoKey" }, [_vm._v("寄养/留守经历")]),
            _vm._v(" "),
            !_vm.liveStateList.find(function(el) {
              return el.status == true
            })
              ? _c(
                  "div",
                  {
                    staticClass: "toSelect",
                    on: {
                      click: function($event) {
                        _vm.liveStateStatus = true
                      }
                    }
                  },
                  [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                )
              : _c(
                  "div",
                  {
                    staticClass: "infoValue",
                    on: {
                      click: function($event) {
                        _vm.liveStateStatus = true
                      }
                    }
                  },
                  _vm._l(_vm.liveStateList, function(item) {
                    return _c("span", { key: item.key }, [
                      _vm._v(_vm._s(item.status ? item.name : "") + " ")
                    ])
                  })
                )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fffItem", staticStyle: { "margin-bottom": "0" } },
          [
            _c("div", { staticClass: "title" }, [_vm._v("个人状况")]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [
                _vm._v("对本专业的满意度")
              ]),
              _vm._v(" "),
              _vm.scaleUserBespeakRegister.majorSatisfaction === ""
                ? _c(
                    "div",
                    {
                      staticClass: "toSelect",
                      on: {
                        click: function($event) {
                          _vm.majorSatisfactionStatus = true
                        }
                      }
                    },
                    [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "infoValue",
                      on: {
                        click: function($event) {
                          _vm.majorSatisfactionStatus = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("isMajorSatisfaction")(
                            _vm.scaleUserBespeakRegister.majorSatisfaction
                          )
                        )
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "infoItem", staticStyle: { height: "2.2rem" } },
              [
                _c("div", { staticClass: "infoKey" }, [
                  _vm._v(
                    "是否经历了负性生活事件情况，如重要他人去世、被校园霸凌、失恋等"
                  )
                ]),
                _vm._v(" "),
                _vm.scaleUserBespeakRegister.incident !== ""
                  ? _c(
                      "div",
                      {
                        staticClass: "infoValue maxWidth",
                        on: { click: _vm.openIncident }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("isIncident")(
                              _vm.scaleUserBespeakRegister.incident
                            )
                          )
                        )
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "toSelect",
                        on: {
                          click: function($event) {
                            _vm.incidentStatus = true
                          }
                        }
                      },
                      [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                    )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [
                _vm._v("您是否曾自伤或自杀")
              ]),
              _vm._v(" "),
              _vm.scaleUserBespeakRegister.selfInflicted === ""
                ? _c(
                    "div",
                    {
                      staticClass: "toSelect",
                      on: {
                        click: function($event) {
                          _vm.selfInflictedStatus = true
                        }
                      }
                    },
                    [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "infoValue",
                      on: {
                        click: function($event) {
                          _vm.selfInflictedStatus = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("isSelfInflicted")(
                            _vm.scaleUserBespeakRegister.selfInflicted
                          )
                        )
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("个人精神障碍史")]),
              _vm._v(" "),
              _vm.scaleUserBespeakRegister.selfMentalIllness !== ""
                ? _c(
                    "div",
                    {
                      staticClass: "infoValue maxWidth",
                      on: { click: _vm.openSelfMentalIllness }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("isSelfMentalIllness")(
                            _vm.scaleUserBespeakRegister.selfMentalIllness
                          )
                        )
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "toSelect",
                      on: {
                        click: function($event) {
                          _vm.selfMentalIllnessStatus = true
                        }
                      }
                    },
                    [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [_vm._v("咨询经历")]),
              _vm._v(" "),
              _vm.scaleUserBespeakRegister.consultHistory === ""
                ? _c(
                    "div",
                    {
                      staticClass: "toSelect",
                      on: {
                        click: function($event) {
                          _vm.consultHistoryStatus = true
                        }
                      }
                    },
                    [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "infoValue",
                      on: {
                        click: function($event) {
                          _vm.consultHistoryStatus = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("isConsultHistory")(
                            _vm.scaleUserBespeakRegister.consultHistory
                          )
                        )
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _c("div", { staticClass: "infoKey" }, [
                _vm._v("评估目前压力水平")
              ]),
              _vm._v(" "),
              _vm.scaleUserBespeakRegister.pressureValue === ""
                ? _c(
                    "div",
                    {
                      staticClass: "toSelect",
                      on: {
                        click: function($event) {
                          _vm.pressureValueStatus = true
                        }
                      }
                    },
                    [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "infoValue",
                      on: {
                        click: function($event) {
                          _vm.pressureValueStatus = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("isPressureValue")(
                            _vm.scaleUserBespeakRegister.pressureValue
                          )
                        )
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "infoItem", staticStyle: { height: "1.5rem" } },
              [
                _c("div", { staticClass: "infoKey" }, [
                  _vm._v("目前主要问题(可多选)")
                ]),
                _vm._v(" "),
                _vm.scaleUserBespeakRegister.troubles === ""
                  ? _c(
                      "div",
                      {
                        staticClass: "toSelect",
                        on: {
                          click: function($event) {
                            _vm.troublesStatus = true
                          }
                        }
                      },
                      [_vm._v("请选择 "), _c("div", { staticClass: "more" })]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "infoValue maxWidth",
                        on: {
                          click: function($event) {
                            _vm.troublesStatus = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.scaleUserBespeakRegister.troubles))]
                    )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "c-nextBox" }, [
          _c("div", { staticClass: "nextBtn", on: { click: _vm.next } }, [
            _vm._v("下一步")
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.birthplaceStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.birthplaceStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("选择出生地")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.birthplace(1)
                    }
                  }
                },
                [_vm._v("城市")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.birthplace(0)
                    }
                  }
                },
                [_vm._v("农村")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.onlyChildStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.onlyChildStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("是否独生子女")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._v("否，家中排行"),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.scaleUserBespeakRegister.onlyChild,
                        expression: "scaleUserBespeakRegister.onlyChild"
                      }
                    ],
                    attrs: { type: "number", placeholder: "请输入数字" },
                    domProps: { value: _vm.scaleUserBespeakRegister.onlyChild },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      blur: _vm.onlyChildBlur,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.scaleUserBespeakRegister,
                          "onlyChild",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.onlyChild(0)
                    }
                  }
                },
                [_vm._v("是")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.religiousBeliefsStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.religiousBeliefsStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("宗教信仰")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._v("有，具体是"),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.scaleUserBespeakRegister.religiousBeliefs,
                        expression: "scaleUserBespeakRegister.religiousBeliefs"
                      }
                    ],
                    attrs: { type: "text", placeholder: "请输入宗教" },
                    domProps: {
                      value: _vm.scaleUserBespeakRegister.religiousBeliefs
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      blur: _vm.religiousBeliefsBlur,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.scaleUserBespeakRegister,
                          "religiousBeliefs",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.religiousBeliefs("0")
                    }
                  }
                },
                [_vm._v("无")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.familyStateStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.familyStateStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("家庭结构")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyState(0)
                    }
                  }
                },
                [_vm._v("完整")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyState(1)
                    }
                  }
                },
                [_vm._v("单亲")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyState(2)
                    }
                  }
                },
                [_vm._v("重组家庭")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyState(3)
                    }
                  }
                },
                [_vm._v("孤儿")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.parentMaritalStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.parentMaritalStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("父母婚姻状况")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.parentMarital(0)
                    }
                  }
                },
                [_vm._v("良好")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.parentMarital(1)
                    }
                  }
                },
                [_vm._v("一般")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.parentMarital(2)
                    }
                  }
                },
                [_vm._v("离婚")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.parentMarital(3)
                    }
                  }
                },
                [_vm._v("再婚")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.familyEconomicStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.familyEconomicStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("家庭经济条件")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyEconomic(3)
                    }
                  }
                },
                [_vm._v("富裕")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyEconomic(0)
                    }
                  }
                },
                [_vm._v("较好")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyEconomic(1)
                    }
                  }
                },
                [_vm._v("一般")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyEconomic(2)
                    }
                  }
                },
                [_vm._v("贫困")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.familyMentalIllnessStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.familyMentalIllnessStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("家族精神类疾病史")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyMentalIllness(0)
                    }
                  }
                },
                [_vm._v("无")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyMentalIllness(1)
                    }
                  }
                },
                [_vm._v("有")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.familyHappyStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.familyHappyStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("家庭氛围")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyHappy(0)
                    }
                  }
                },
                [_vm._v("亲密")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyHappy(1)
                    }
                  }
                },
                [_vm._v("融洽")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyHappy(2)
                    }
                  }
                },
                [_vm._v("疏离")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyHappy(3)
                    }
                  }
                },
                [_vm._v("紧张")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.familyHappy(4)
                    }
                  }
                },
                [_vm._v("冲突")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.liveStateStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.liveStateStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("寄养/留守经历")]
              ),
              _vm._v(" "),
              _vm._l(_vm.liveStateList, function(item) {
                return _c(
                  "div",
                  {
                    key: item.key,
                    staticClass: "maskItem",
                    class: { active: item.status },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        item.status = !item.status
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.majorSatisfactionStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.majorSatisfactionStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("对本专业的满意度")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.majorSatisfaction(0)
                    }
                  }
                },
                [_vm._v("非常满意")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.majorSatisfaction(1)
                    }
                  }
                },
                [_vm._v("比较满意")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.majorSatisfaction(2)
                    }
                  }
                },
                [_vm._v("一般")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.majorSatisfaction(3)
                    }
                  }
                },
                [_vm._v("不太满意")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.majorSatisfaction(4)
                    }
                  }
                },
                [_vm._v("非常不满意")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.majorSatisfaction(5)
                    }
                  }
                },
                [_vm._v("无所谓")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.incidentStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.incidentStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._v(
                    "是否经历了负性生活事件情况，如重要他人去世、被校园霸凌、失恋等"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.incident("0")
                    }
                  }
                },
                [_vm._v("无")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.incident("1")
                    }
                  }
                },
                [_vm._v("有，且接受过心理干预")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.incident("2")
                    }
                  }
                },
                [_vm._v("有，未接受过心理干预")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._v("其他"),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.scaleUserBespeakRegister.incident,
                        expression: "scaleUserBespeakRegister.incident"
                      }
                    ],
                    attrs: { type: "text", placeholder: "请输入" },
                    domProps: { value: _vm.scaleUserBespeakRegister.incident },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      blur: _vm.incidentBlur,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.scaleUserBespeakRegister,
                          "incident",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selfInflictedStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.selfInflictedStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("您是否曾自伤或自杀")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfInflicted(0)
                    }
                  }
                },
                [_vm._v("否")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfInflicted(1)
                    }
                  }
                },
                [_vm._v("自伤或自杀想法")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfInflicted(2)
                    }
                  }
                },
                [_vm._v("自伤行为")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfInflicted(3)
                    }
                  }
                },
                [_vm._v("自杀行为")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selfMentalIllnessStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.selfMentalIllnessStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("个人精神障碍史")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfMentalIllness("0")
                    }
                  }
                },
                [_vm._v("无")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfMentalIllness("1")
                    }
                  }
                },
                [_vm._v("小学时发现")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfMentalIllness("2")
                    }
                  }
                },
                [_vm._v("初中时发现")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfMentalIllness("3")
                    }
                  }
                },
                [_vm._v("高中时发现")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.selfMentalIllness("4")
                    }
                  }
                },
                [_vm._v("大学时发现")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._v("其他"),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.scaleUserBespeakRegister.selfMentalIllness,
                        expression: "scaleUserBespeakRegister.selfMentalIllness"
                      }
                    ],
                    attrs: { type: "text", placeholder: "请输入" },
                    domProps: {
                      value: _vm.scaleUserBespeakRegister.selfMentalIllness
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      blur: _vm.selfMentalIllnessBlur,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.scaleUserBespeakRegister,
                          "selfMentalIllness",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.consultHistoryStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.consultHistoryStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("咨询经历")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.consultHistory(0)
                    }
                  }
                },
                [_vm._v("无")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.consultHistory(1)
                    }
                  }
                },
                [_vm._v("有")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pressureValueStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.pressureValueStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTitle",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("评估目前压力水平（请打分，10分水平最高）")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(1)
                    }
                  }
                },
                [_vm._v("1分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(2)
                    }
                  }
                },
                [_vm._v("2分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(3)
                    }
                  }
                },
                [_vm._v("3分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(4)
                    }
                  }
                },
                [_vm._v("4分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(5)
                    }
                  }
                },
                [_vm._v("5分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(6)
                    }
                  }
                },
                [_vm._v("6分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(7)
                    }
                  }
                },
                [_vm._v("7分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(8)
                    }
                  }
                },
                [_vm._v("8分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(9)
                    }
                  }
                },
                [_vm._v("9分")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "maskItem",
                  on: {
                    click: function($event) {
                      _vm.pressureValue(10)
                    }
                  }
                },
                [_vm._v("10分")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.troublesStatus
        ? _c(
            "div",
            {
              staticClass: "maskBox",
              on: {
                click: function($event) {
                  _vm.troublesStatus = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "maskTop",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [_vm._v("目前主要问题（可多选）")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "troublesList" },
                [
                  _vm._l(_vm.troublesList, function(item) {
                    return _c(
                      "div",
                      {
                        staticClass: "troublesItem",
                        class: { active: item.status },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            item.status = !item.status
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "maskBtn", on: { click: _vm.saveTroubles } },
                    [_vm._v("保存")]
                  )
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tipStatus
        ? _c("div", { staticClass: "tipBox" }, [
            _c("div", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.tip))])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "procedure" }, [
      _c("div", { staticClass: "procedureItem" }, [
        _vm._v("\n                    预约时间\n                    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "procedureItem" }, [
        _vm._v("\n                    补充信息\n                    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "procedureItem" }, [
        _vm._v("\n                    等待咨询\n                    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "procedureItem" }, [
        _vm._v("\n                    开始咨询\n                    ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "procedureLine" }, [
      _c("div", { staticClass: "yuan" }),
      _vm._v(" "),
      _c("div", { staticClass: "yLine" }),
      _vm._v(" "),
      _c("div", { staticClass: "yuan" }),
      _vm._v(" "),
      _c("div", { staticClass: "yLine" }),
      _vm._v(" "),
      _c("div", { staticClass: "yuan" }),
      _vm._v(" "),
      _c("div", { staticClass: "yLine" }),
      _vm._v(" "),
      _c("div", { staticClass: "yuan" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47b53dfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b53dfd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/serveInfo.vue
// module id = null
// module chunks = 